import React from 'react';

const Journey = () => {
  return (
    <section
      class="Feautes section"
      style={{ fontFamily: 'Poppins, sans-serif' }}
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-title">
              <h2>Start your Journey with us</h2>
              <img src="img/section-img.png" alt="#" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-12">
            <div class="single-features last">
              <div class="signle-icon">
                <img src="img/users/01.png" alt="Retailer" />
              </div>
              <h3>Retailer</h3>
            </div>
          </div>
          <div class="col-lg-3 col-12">
            <div class="single-features last">
              <div class="signle-icon">
                <img src="img/users/02.png" alt="Distributor" />
              </div>
              <h3>Distributor</h3>
            </div>
          </div>
          <div class="col-lg-3 col-12">
            <div class="single-features last">
              <div class="signle-icon">
                <img src="img/users/03.png" alt="Master Distributor" />
              </div>
              <h3>Master Distributor</h3>
            </div>
          </div>
          <div class="col-lg-3 col-12">
            <div class="single-features last">
              <div class="signle-icon">
                <img src="img/users/04.png" alt="API User" />
              </div>
              <h3>API User</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Journey;
